import * as React from 'react';
import { SVGProps } from 'react';

const SvgPdf = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={25} height={32} viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={24} height={32} rx={3} fill="#F5D7C6" />
    <g clipPath="url(#pdf_svg__a)">
      <rect x={5} y={17} width={20} height={10} rx={1} fill="#D75811" />
      <path
        d="M6.527 25h1.327v-2h1.222c1.336 0 2.228-.86 2.228-2.166v-.009c0-1.305-.892-2.166-2.228-2.166H6.527V25Zm2.224-5.291c.76 0 1.208.4 1.208 1.12v.01c0 .72-.448 1.124-1.208 1.124h-.897V19.71h.897ZM12.091 25h2.421c1.903 0 3.024-1.182 3.024-3.195v-.009c0-2.008-1.125-3.137-3.024-3.137h-2.421V25Zm1.327-1.099v-4.148h.936c1.165 0 1.828.725 1.828 2.048v.009c0 1.37-.641 2.091-1.828 2.091h-.936ZM18.393 25h1.327v-2.496h2.58v-1.05h-2.58v-1.701h2.825v-1.094h-4.152V25Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="pdf_svg__a">
        <rect x={5} y={17} width={20} height={10} rx={1} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgPdf;
